<template>
  <DropdownWrapper
    :transform="transform"
    :isShowCustomPicker="showCustomPicker"
  >
    <b-dropdown
      ref="dropdown"
      id="dropdown-text"
      variant="unset"
      toggleClass="p-0 border-none"
      menu-class="setting-box color-palette-picker-dropdown"
      :boundary="boundary ? boundary : 'window'"
      dropright
      @hide="closePalette"
      @show="palatteShow"
      @shown="palatteShown"
    >
      <template #button-content>
        <!-- Btn Custom -->
        <template v-if="$slots.icon">
          <slot ref="dropdownBTN" name="icon"></slot>
        </template>

        <!-- Btn Color -->
        <ColorDisplay
          ref="dropdownBTN"
          v-if="!$slots.icon"
          :color="value"
          :alpha="alpha"
        />
      </template>

      <div v-if="showMenu" class="title">
        <h4 class="fs-db-24 mb-0" style="color: #373e44 !important">
          {{ getHeader() }}
        </h4>
        <span class="close-btn" @click="closePalette"
          ><i class="fal fa-times"></i
        ></span>
      </div>
      <div :class="showMenu ? 'menu-picker mt-gd-1' : 'd-none'">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="fs-dbb-20 mb-0" style="color: #373e44 !important">
            {{ $t("engine.colorPicker.lblThemeColor", languageEngine) }}
          </h5>
          <span
            class=""
            style="cursor: pointer"
            @click="
              $store.dispatch('design/component/elActive', {
                elementID: ['website_theme', 'color_theme', 'customize'],
              })
            "
            ><i class="far fa-edit"></i
          ></span>
        </div>
        <div class="mt-gd-1" style="line-height: 0">
          <div
            v-for="color_index in 5"
            :key="'color_index' + color_index"
            class="d-flex mt-gd-1"
          >
            <div class="cursor-pointer" @click="setTemplateColor(color_index)">
              <div
                :style="`width: 24px; border-radius: 2px; height: 24px; background-color: rgb(${
                  templateColor[$helper.color.colorKey(color_index)]
                }); border: 1px solid ${getBorderColor(
                  templateColor[$helper.color.colorKey(color_index)]
                )};`"
              ></div>
            </div>
            <div class="d-flex" style="margin-left: 8px">
              <PaletteTemplateColor
                v-for="shade_index in 5"
                @click="setTemplateColor(color_index, shade_index)"
                :class="{ active: getActiveColor(color_index, shade_index) }"
                :key="'shade_index' + shade_index"
                :style="`background-color: rgb(${
                  templateColor[
                    $helper.color.colorKey(color_index, shade_index)
                  ]
                }); border: 1px solid ${getBorderColor(
                  templateColor[
                    $helper.color.colorKey(color_index, shade_index)
                  ]
                )};`"
              >
              </PaletteTemplateColor>
            </div>
          </div>
        </div>
        <!-- ######## -->
        <div class="d-flex justify-content-between align-items-center mt-gd-1">
          <h5 class="fs-dbb-20 mb-0" style="color: #373e44 !important">
            {{ $t("engine.colorPicker.lblCustomColor", languageEngine) }}
          </h5>
        </div>
        <div class="palette-container mt-gd-1">
          <AddColor
            @click="openCustomColor"
            class=""
            style="
              display: inline-flex;
              margin: 4px 0px 4px 0;
              color: #24bee2;
              border-color: #24bee2;
              height: 24px;
              width: 24px;
            "
          >
            <i class="far fa-plus center-hv" style="font-size: 14px"></i>
          </AddColor>
          <PaletteColor
            v-if="is_alpha"
            @click="setTransparent()"
            class="d-inline-block"
            :class="{
              active:
                !value || (value == '#FFFFFF' && colorAlpha == 0)
                  ? true
                  : false,
            }"
            :style="`background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
              margin: 4px 0px 4px 0px; opacity: 50%; border: 1px solid var(--line)`"
          ></PaletteColor>

          <PaletteColor
            v-for="(color, color_index) in customColorsDisplay"
            @click="setCustomColor(color)"
            class="d-inline-block"
            :key="`color_index${color_index}`"
            :class="{
              active:
                color.toUpperCase() == value.toUpperCase() &&
                !(value == '#FFFFFF' && colorAlpha == 0)
                  ? true
                  : false,
            }"
            :style="`background-color: ${color}; margin: 4px 0px 4px 0px; border: 1px solid ${getBorderColor(
              color
            )};`"
          >
            <!-- <i class="far fa-check"></i> -->
          </PaletteColor>
        </div>
        <span
          v-if="is_alpha && colorAlpha != 0"
          class="mt-gd-1"
          style="font-size: 14px; font-weight: bold"
          >{{$t('engine.colorPicker.lblOpacity', languageEngine)}}</span
        >
        <AlphaWrapper
          v-if="is_alpha && colorAlpha != 0"
          class="d-flex align-items-center mt-gd-1 alpha-wrapper"
        >
          <SliderWrapper class="flex-grow-1">
            <Slider
              type="range"
              :color="$helper.color.getColor(value)"
              min="1"
              max="100"
              v-model="colorAlpha"
              class="slider"
            />
          </SliderWrapper>
          <FormInputNumber2
            id="input-alpha"
            class="input-alpha"
            ref="InputAlpha"
            type="number"
            :min="1"
            :max="100"
            unit="%"
            v-model="root.value.alpha"
            @blur="onBlurInputAlpha"
            @keydown.enter="onBlurInputAlpha"
            @keydown="onTyping"
          />
        </AlphaWrapper>
        <div class="d-flex justify-content-between align-items-center mt-gd-1">
          <span
            class="text-primary"
            type="button"
            style="white-space: nowrap"
            @click="openCustomColor"
          >
            <p class="fs-sa-14 mb-0">
              <i class="fal fa-plus"></i>
              {{ $t("engine.colorPicker.btnAddColor", languageEngine) }}
            </p>
          </span>
          <span>
            <p class="fs-sa-14 mb-0" style="color: #53585d !important">
              {{ colorCode }}
            </p>
          </span>
        </div>
      </div>

      <div
        v-if="showCustomPicker"
        :class="showCustomPicker ? 'picker-tool' : 'd-none'"
      >
        <div>
          <ColorPickerTool v-model="tempCustomColor" />
          <div class="d-flex justify-content-between mt-gd-2">
            <b-button size="sm" variant="blue" @click.stop="addCustomColor"
              ><p class="fs-sa-14 mb-0">
                <i class="fal fa-plus mr-5"></i>
                {{
                  $t("engine.colorPicker.customColor.btnAdd", languageEngine)
                }}
              </p></b-button
            >
            <b-button
              size="sm"
              class="mt-0"
              variant="default"
              @click.stop="closeCustomColor"
              ><p class="fs-sa-14 mb-0">
                <i class="fal fa-times mr-5"></i>
                {{
                  $t("engine.colorPicker.customColor.btnCancel", languageEngine)
                }}
              </p></b-button
            >
          </div>
        </div>
      </div>
    </b-dropdown>
  </DropdownWrapper>
</template>

<script>
import { mapGetters } from "vuex";
import {
  DropdownWrapper,
  PaletteColor,
  PaletteTemplateColor,
  Slider,
  SliderWrapper,
  AlphaWrapper,
  // DisplayWrapper,
  AddColor,
} from "./PalettePicker.styled";
import defaultColor from "./palette.config";
import ColorPickerTool from "@components_system/Shared/Tools/Box/ColorPicker/ColorPickerTool";
import ColorDisplay from "@components_system/Shared/Tools/ColorDisplay/ColorDisplay";
import FormInputNumber2 from "@components_system/Shared/Tools/FormInputNumber2/FormInputNumber2";

export default {
  props: {
    value: {
      default: "#FFFFFF",
      required: true,
    },
    alpha: {
      // default: 100,
      // type: Number,
    },
    boundary: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      showMenu: true,
      showCustomPicker: false,
      tempCustomColor: undefined,
      defaultColor,
      transform: [],
      root: {
        value: {
          color: undefined,
          alpha: undefined,
        },
      },
      isDraging: false,
      isTyping: false,
    };
  },
  components: {
    DropdownWrapper,
    AddColor,
    PaletteColor,
    PaletteTemplateColor,
    Slider,
    SliderWrapper,
    AlphaWrapper,
    // DisplayWrapper,
    ColorPickerTool,
    ColorDisplay,
    FormInputNumber2,
  },
  methods: {
    closePalette(e) {
      this.showMenu = true;
      this.showCustomPicker = false;
      this.$refs.dropdown.hide(true);
      this.$emit("hide", e);
    },
    palatteShow(event) {
      this.$emit("show", event);
    },
    palatteShown() {
      this.$refs.dropdown.show(true);
      const palettePicker = document
        .querySelector(".color-palette-picker-dropdown.show")
        .getBoundingClientRect();
      if (palettePicker.top <= 0) {
        let transform = document.querySelector(
          ".color-palette-picker-dropdown.show"
        ).style.transform;
        transform = transform.replace("translate3d(", "");
        transform = transform.replace(")", "");
        transform = transform.replace("px", "");
        this.transform = transform.split(",");
      }
      this.$emit("shown");
    },
    addCustomColor() {
      this.root.value.color = this.tempCustomColor;

      if (this.customColors.includes(this.tempCustomColor)) {
        this.customColors.splice(
          this.customColors.indexOf(this.tempCustomColor),
          1
        );
        this.customColors.unshift(this.tempCustomColor);
        this.$emit("input", this.tempCustomColor);
        this.$emit("change", {
          source: "addCustomColorExists",
          color: this.root.value.color,
          alpha: this.root.value.alpha,
        });
      } else {
        this.customColors.unshift(this.tempCustomColor);
        this.$emit("input", this.tempCustomColor);
        this.$emit("change", {
          source: "addCustomColor",
          color: this.root.value.color,
          alpha: this.root.value.alpha,
        });
      }
      // this.customColors.slice(0, 13);
      this.$store.dispatch(`${this.module}/snapshot/genSnapshot`);
      this.showMenu = true;
      this.showCustomPicker = false;
    },
    openCustomColor() {
      this.tempCustomColor = this.colorCode;
      this.showMenu = false;
      this.showCustomPicker = true;
    },
    closeCustomColor() {
      this.tempCustomColor = this.colorCode;
      this.showMenu = true;
      this.showCustomPicker = false;
    },
    setTransparent() {
      this.root.value.color = "#FFFFFF";
      this.root.value.alpha = parseInt(0);

      this.$emit("input", "#FFFFFF");
      this.$emit("update:alpha", parseInt(0));
      this.$emit("change", {
        source: "setTransparent",
        color: this.root.value.color,
        alpha: this.root.value.alpha,
      });
    },
    setTemplateColor(colorIndex, shadeIndex) {
      if (!shadeIndex) {
        const themeColor = this.templateColor;
        let tmpColor = themeColor[`--tpc-${colorIndex}`];
        for (let i = 1; i <= 5; i++) {
          let shadeColor = themeColor[`--tpc-${colorIndex}${i}`];
          if (tmpColor == shadeColor) {
            shadeIndex = i;
          }
        }
      }

      this.root.value.color = this.$helper.color.colorKey(
        colorIndex,
        shadeIndex
      );

      this.root.value.alpha = parseInt(100);
      this.$emit("update:alpha", parseInt(100));
      this.$emit("input", this.$helper.color.colorKey(colorIndex, shadeIndex));
      this.$emit("change", {
        source: "setTemplateColor",
        color: this.root.value.color,
        alpha: this.root.value.alpha,
      });
    },
    setCustomColor(color) {
      this.root.value.color = color;
      this.root.value.alpha = parseInt(100);

      this.$emit("input", color);
      this.$emit("update:alpha", parseInt(100));
      this.$emit("change", {
        source: "setCustomColor",
        color: this.root.value.color,
        alpha: this.root.value.alpha,
      });
    },
    getHeader() {
      if (this.showMenu) {
        return this.$t(
          "engine.colorPicker.lblHeaderColorPicker",
          this.languageEngine
        );
      }

      if (this.showCustomPicker) {
        return this.$t(
          "engine.colorPicker.lblHeaderCustomColor",
          this.languageEngine
        );
      }
    },
    getBorderColor(color) {
      let hex = "";
      let isHexColor = color.includes("#");
      if (isHexColor) {
        hex = color;
      } else {
        let arrRGB = color.split(",");
        hex = this.$helper.color.rgbToHex(arrRGB[0], arrRGB[1], arrRGB[2]);
      }

      if (this.$helper.color.hexThreshold(hex) > 0.97) {
        return "var(--line)";
      } else {
        if (isHexColor) {
          return color;
        } else {
          return "rgb(" + color + ")";
        }
      }
    },
    onTyping() {
      this.isTyping = true;
    },
    onBlurInputAlpha() {
      this.isTyping = false;
      if (
        this.root.value.alpha == null ||
        this.root.value.alpha == undefined ||
        this.root.value.alpha == ""
      ) {
        this.root.value.alpha = 1;
      } else {
        if (this.root.value.alpha > 100) {
          this.root.value.alpha = 100;
        } else if (this.root.value.alpha < 1) {
          this.root.value.alpha = 1;
        } else {
          this.root.value.alpha = Math.ceil(this.root.value.alpha);
        }
      }

      this.$emit("update:alpha", parseInt(this.root.value.alpha));
      this.$refs.InputAlpha.$el.blur();
    },
    ckeckExistColor() {
      let isHexColor = this.value.includes("#");
      if (isHexColor && !this.customColors.includes(this.value)) {
        this.customColors.unshift(this.value);
      }
    },
    getActiveColor(colorIndex, shadeIndex) {
      // console.log("this.value", this.value);
      if (this.value && this.value.includes("tpc")) {
        if (this.value.length == 8) {
          return (
            this.value.replace("--tpc-", "") == colorIndex + "" + shadeIndex
          );
        } else {
          const themeColor = this.templateColor;
          let tmpColorIndex = this.value.replace("--tpc-", "");
          let tmpColor = themeColor[`--tpc-${tmpColorIndex}`];

          for (let i = 1; i <= 5; i++) {
            let tmpShadeColor = themeColor[`--tpc-${colorIndex}${i}`];
            let tmpShadeIndex = 1;
            if (tmpColor == tmpShadeColor) {
              tmpShadeIndex = i;
              return (
                tmpColorIndex + "" + tmpShadeIndex ==
                colorIndex + "" + shadeIndex
              );
            }
          }
          return false;
        }
      } else {
        return false;
      }
    },
  },
  computed: {
    ...mapGetters({
      module: "module",
      mode: "design/mode",
    }),
    customColorsDisplay() {
      return [...this.customColors];
    },
    customColors() {
      return this.$store.getters[`${this.module}/metadata/customColors`];
    },
    templateColor() {
      return this.$store.getters[`${this.module}/metadata/templateColor`];
    },
    appearance() {
      return this.$store.getters[`${this.module}/metadata/appearance`];
    },
    colorCode() {
      if (this.value && this.value.includes("tpc")) {
        if (!this.templateColor[this.value]) return null;
        let rgbNumSplit = this.templateColor[this.value].split(",");

        let r = parseInt(rgbNumSplit[0]);
        let g = parseInt(rgbNumSplit[1]);
        let b = parseInt(rgbNumSplit[2]);

        return this.$helper.color.rgbToHex(r, g, b).toUpperCase();
      }

      return this.value ? this.value.toUpperCase() : null;
    },
    colorAlpha: {
      get() {
        return this.is_alpha ? this.root.value.alpha : 100;
      },
      set(val) {
        this.isDraging = true;
        let value = val == "" ? 0 : val;
        this.root.value.alpha = value;

        setTimeout(() => {
          this.isDraging = false;
          if (!this.isDraging && value == this.root.value.alpha) {
            this.$emit("update:alpha", parseInt(this.root.value.alpha));
            this.$emit("change", {
              source: "onChangeAlpha",
              color: this.value,
              alpha: parseInt(this.root.value.alpha),
            });
          }
        }, 500);
      },
    },
    is_alpha() {
      return this.alpha == undefined ? false : true;
    },
    languageEngine() {
      return this.$store.getters[
        `${this.module}/userPreference/languageEngine`
      ];
    },
  },
  mounted() {
    this.root.value.alpha = this.alpha == undefined ? 100 : this.alpha;
    this.tempCustomColor = this.colorCode;
    this.ckeckExistColor();
  },
  watch: {
    value() {
      this.ckeckExistColor();
    },
    alpha() {
      this.root.value.alpha = this.alpha == undefined ? 100 : this.alpha;
    },
  },
};
</script>

<style lang="scss" scoped>
#dropdown-text .text-primary p {
  color: var(--primary) !important;
}

#dropdown-text .btn-blue p {
  color: #ffffff !important;
}

#dropdown-text .btn-default p {
  color: #53585d !important;
}
.alpha-wrapper {
  gap: 8px;
  .input-unit {
    &::after {
      line-height: 12px;
    }
  }
}
</style>
